module.exports = __webpack_public_path__ + "img/green_interview.fde79e96.svg";